export let ALL_ROLE = null
export let subareaAspect = [
  {
    name: '东',
    type: 'east'
  },
  {
    name: '西',
    type: 'west'
  },
  {
    name: '南',
    type: 'south'
  },
  {
    name: '北',
    type: 'north'
  },
  {
    name: '东南',
    type: 'south_east'
  },
  {
    name: '西南',
    type: 'south_west'
  },
  {
    name: '东北',
    type: 'north_east'
  },
  {
    name: '西北',
    type: 'north_west'
  },
  {
    name: '其他',
    type: 'other'
  }
]
export let subareaType = [
  {
    type: 0,
    name: '主卧'
  },
  {
    type: 1,
    name: '次卧'
  },
  {
    type: 2,
    name: '客卧'
  },
  {
    type: 3,
    name: '床位'
  },
  {
    type: 4,
    name: '主卧带卫'
  },
  {
    type: 5,
    name: '书房'
  },
  {
    type: 6,
    name: '小次卧'
  },
  {
    type: 7,
    name: '东次卧'
  },
  {
    type: 8,
    name: '西次卧'
  },
  {
    type: 9,
    name: '南次卧'
  },
  {
    type: 10,
    name: '北次卧'
  },
  {
    type: 11,
    name: '客厅隔'
  },
  {
    type: 12,
    name: '餐厅隔'
  },
  {
    type: 13,
    name: '厨房隔'
  },
]
